import React from 'react';
function ShowerIcon({
  className
}: {
  className?: string;
}) {
  return <svg className={className} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true" focusable="false" data-id="element-159">
      <path d="M4 4v6a8 8 0 0 0 16 0V4" data-id="element-160" />
      <line x1="12" y1="14" x2="12" y2="14.01" data-id="element-161" />
      <line x1="12" y1="18" x2="12" y2="18.01" data-id="element-162" />
      <line x1="8" y1="16" x2="8" y2="16.01" data-id="element-163" />
      <line x1="16" y1="16" x2="16" y2="16.01" data-id="element-164" />
      <line x1="10" y1="20" x2="10" y2="20.01" data-id="element-165" />
      <line x1="14" y1="20" x2="14" y2="20.01" data-id="element-166" />
    </svg>;
}
export function Hero() {
  return <section className="relative pt-4 pb-8 md:pt-8 md:pb-12 overflow-hidden" aria-label="Presentación de El Maestro de las Mamparas" style={{
    contain: 'layout'
  }} data-id="element-167">
      <div className="container mx-auto px-4 relative z-10" data-id="element-168">
        <div className="flex flex-col items-center" data-id="element-169">
          <div className="flex-1 text-center max-w-4xl" data-id="element-170">
            <div className="inline-flex items-center gap-2 px-3 py-1.5 mb-4 rounded-full border border-gold/40 bg-gold/10" data-id="element-171">
              <ShowerIcon className="w-3.5 h-3.5 text-gold" data-id="element-172" />
              <span className="text-gold text-xs font-semibold uppercase tracking-wider" data-id="element-173">
                El Maestro de las Mamparas
              </span>
            </div>
            <h1 className="md:text-7xl font-bold mb-6 text-white text-[26px] leading-tight" data-id="element-174">
              Todo tu taller de mamparas listo. Desde hoy.
            </h1>

            <div className="mb-8 relative" data-id="element-175">
              <div className="absolute inset-0 z-0 pointer-events-none" aria-hidden="true" style={{
              background: 'radial-gradient(circle at center, rgba(245,200,66,0.20) 0%, rgba(245,200,66,0) 60%)'
            }} data-id="element-176"></div>
              <img src="https://cdn.magicpatterns.com/uploads/7BkzCbELLsUwyvco8cmoUC/Texto_del_parrafo.webp" alt="El Maestro de las Mamparas — El sistema definitivo para carpinteros e instaladores" className="mx-auto block w-[300px] md:w-[460px] h-auto relative z-10 drop-shadow-[0_0_40px_rgba(245,200,66,0.25)]" width={460} height={460} sizes="(min-width: 768px) 460px, 300px"
            // @ts-ignore
            fetchpriority="high" decoding="async" loading="eager" data-id="element-177" />
            </div>

            <p className="text-lg mb-8 max-w-2xl mx-auto text-white" data-id="element-178">
              Medidas exactas, cristales sin error, instalación prolija y
              presupuestos con ganancia real. Sin improvisar ni perder vidrio.
            </p>

            <button onClick={() => {
            const target = document.getElementById('cta-comprar');
            if (target) {
              target.scrollIntoView({
                behavior: 'smooth',
                block: 'end'
              });
            }
          }} className="inline-flex items-center justify-center w-full sm:w-auto px-8 py-5 text-lg font-bold text-background bg-gold rounded-xl hover:bg-gold/90 transition-colors uppercase tracking-wider cursor-pointer focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-gold shadow-[0_0_20px_rgba(245,200,66,0.3)] hover:shadow-[0_0_30px_rgba(245,200,66,0.5)]" data-id="element-179">
              🚿 → QUIERO MI SISTEMA MAESTRO AHORA
            </button>

            <div className="flex flex-wrap justify-center gap-4 mt-8 mb-6" role="list" aria-label="Características principales" data-id="element-180">
              <div className="flex items-center gap-2 bg-surface px-4 py-2 rounded-lg border border-white/5" role="listitem" data-id="element-181">
                <span className="text-2xl" aria-hidden="true" data-id="element-182">
                  📄
                </span>
                <span className="font-medium text-sm" data-id="element-183">100% PDF</span>
              </div>
              <div className="flex items-center gap-2 bg-surface px-4 py-2 rounded-lg border border-white/5" role="listitem" data-id="element-184">
                <span className="text-2xl" aria-hidden="true" data-id="element-185">
                  ⚡
                </span>
                <span className="font-medium text-sm" data-id="element-186">Acceso en 5 min</span>
              </div>
              <div className="flex items-center gap-2 bg-surface px-4 py-2 rounded-lg border border-white/5" role="listitem" data-id="element-187">
                <span className="text-2xl" aria-hidden="true" data-id="element-188">
                  🇦🇷
                </span>
                <span className="font-medium text-sm" data-id="element-189">
                  Corredizo → Batiente → Paño Fijo
                </span>
              </div>
              <div className="flex items-center gap-2 bg-surface px-4 py-2 rounded-lg border border-white/5" role="listitem" data-id="element-190">
                <span className="text-2xl" aria-hidden="true" data-id="element-191">
                  🔧
                </span>
                <span className="font-medium text-sm" data-id="element-192">
                  Todas las tipologías
                </span>
              </div>
            </div>

            <div className="flex flex-wrap justify-center items-center gap-6 mt-6 text-sm text-gray-400" data-id="element-193">
              <div className="flex items-center gap-2" data-id="element-194">
                <span className="text-gold" aria-hidden="true" data-id="element-195">
                  🛡️
                </span>
                <span data-id="element-196">Garantía 7 días</span>
              </div>
              <div className="flex items-center gap-2" data-id="element-197">
                <span className="text-gold" aria-hidden="true" data-id="element-198">
                  🔒
                </span>
                <span data-id="element-199">Pago seguro</span>
              </div>
              <div className="flex items-center gap-2" data-id="element-200">
                <span className="text-gold" aria-hidden="true" data-id="element-201">
                  💳
                </span>
                <span data-id="element-202">Mercado Pago</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>;
}